<c-card *transloco="let t">
    <c-card-body class="px-2" *ngIf="okService">


        <app-worker-reports-menu></app-worker-reports-menu>

        <div class="row">
          <div class="col-sm-8">
            <h3>{{ t('Report: Last Sync') }}</h3>
            <p>{{ t("Check to see when the worker's mobile app last synced with OK Alone.") }}</p>
          </div>
          <div class="col-sm-4 text-end">
            <button type="button" class="btn btn-light mb-2" aria-expanded="false" (click)="export()">
              <i class="fa-solid fa-file-excel"></i> {{ t('Export Report') }}
            </button>
          </div>
        </div>

          <div class="card mb-2">
            <div class="card-header" data-bs-toggle="collapse" data-bs-target="#collapseExample" aria-expanded="true" aria-controls="collapseExample">
              <i class="fa-solid fa-chevron-down"></i> {{ t('Filter Results') }}
            </div>
            <div class="show" id="collapseExample">
              <div class="card-body">

                <form cForm >
                  <div class="row mb-2 d-flex justify-content-center">
                    <div class="col-sm-6">
                      <c-input-group>
                        <span cInputGroupText><svg cIcon name="cil-calendar"></svg>&nbsp;&nbsp; {{ t('Dates') }}</span>
                        <input type="text" ngxDaterangepickerMd  [locale]="{format: 'DD-MM-YYYY',displayFormat: 'D MMM YYYY'}" [autoApply]="true" [closeOnAutoApply]="true" [(ngModel)]="selected" name="datetime"  class="form-control"/>
                      </c-input-group>
                    </div>
                  </div>
                  <div class="row d-flex justify-content-center mb-2">

                    <ng-container *ngIf="okService.groups.length > 0 && okService.hasFeature('groups')">
                      <label  class="col-sm-2 col-form-label text-end" >
                        <b>{{ t('Group') }}</b>
                      </label>
                      <div class="col-sm-4">
                        <ng-select
                        [items]="groups"
                        name="group"
                        [(ngModel)]="filter.group"
                        bindLabel="name"
                        bindValue="id"
                        placeholder="{{ t('Group') }}">
                        </ng-select>
                      </div>
                    </ng-container>

                  </div>
                  <div class="row d-flex justify-content-center mb-2">

                  <label  class="col-sm-2 col-form-label text-end" >
                    <b>{{ t('Status') }}</b>
                  </label>
                  <div class="col-sm-4">
                    <ng-select
                    [items]="statuses"
                    name="status"
                    [(ngModel)]="filter.status"
                    multiple="true"
                    bindLabel="name"
                    bindValue="id">
                    </ng-select>
                  </div>
                </div>

                  <div class="row d-flex justify-content-center mb-2">
                    <div class="col-sm-3 d-flex justify-content-end">
                      <button cButton class="btn btn-info text-white" type="submit"  (click)="updateFilter()">
                        <i class="fa-solid fa-magnifying-glass"></i>
                        <span class="d-none d-lg-inline">
                          {{ t('Search') }}
                        </span>
                      </button>
                    </div>
                  &nbsp;&nbsp;&nbsp;&nbsp;
                    <div class="col-sm-3">
                      <button cButton class="btn btn-light" type="submit"  (click)="clearFilter()">
                        <i class="fa-solid fa-xmark"></i>
                        <span class="d-none d-lg-inline">
                          {{ t('Clear Filter') }}
                        </span>
                      </button>
                    </div>
                </div>

                </form>

              </div>
            </div>
          </div>


          <c-row *ngIf="syncs">
            <c-col>

              <table
              [hover]="true"
              [responsive]="true"
              [striped]="true"
              align="middle"
              cTable
              class="mb-0 border"
              >
                <thead>
                  <tr>
                    <th scope="col">{{ t('Worker') }}</th>
                    <th scope="col">{{ t('Last Sync') }}</th>
                    <th scope="col">{{ t('Status') }}</th>
                    <th scope="col">{{ t('Last Location') }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let sync of syncs">
                    <td>
                      <span><b>{{sync.name}}</b></span>
                      <br/>
                      {{sync.email}}
                      <br/>
                      <div class="small text-medium-emphasis">
                        <span>{{sync.phone}} <span *ngIf="sync.phone && sync.cell">/</span> {{sync.cell}}</span>
                      </div>
                    </td>
                    <td>
                      <span>{{sync.last_sync}}</span>
                    </td>
                    <td>
                      <span class="badge text-dark"
                      [class.bg-danger]="sync.status=='Help'"
                      [class.bg-success]="sync.status=='Ok'"
                      [class.bg-warning]="sync.status=='Overdue'"
                      [class.text-white]="sync.status=='Help' || sync.status=='Ok' || sync.status=='Overdue'"
                      >
                        {{sync.status}}
                      </span>
                      <br/>
                      <span>
                          {{sync.status_time}}
                      </span>
                    </td>
                    <td>
                      <span>
                        {{sync.loc_time}}
                      </span>
                    </td>

                  </tr>
                </tbody>

              </table>

            </c-col>
          </c-row>

    </c-card-body>
  </c-card>

